var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalSearchSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6021.722,14.693l-6.444-6.446a7.339,7.339,0,0,1-4.459,1.5A7.384,7.384,0,0,1-6040,2.377,7.383,7.383,0,0,1-6032.625-5a7.384,7.384,0,0,1,7.376,7.376,7.334,7.334,0,0,1-1.5,4.456l6.446,6.446a1,1,0,0,1,0,1.414,1,1,0,0,1-.708.292A1,1,0,0,1-6021.722,14.693ZM-6038,2.377a5.381,5.381,0,0,0,5.374,5.375,5.381,5.381,0,0,0,5.375-5.375A5.38,5.38,0,0,0-6032.625-3,5.381,5.381,0,0,0-6038,2.377Z",
    transform: "translate(6040 4.999)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchSelected);
export default __webpack_public_path__ + "static/media/GlobalSearchSelected.68fb762c608ee8cd218cfe24eeb31e12.svg";
export { ForwardRef as ReactComponent };